import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["monthly", "annual", "billingLink", "intervalInput", "priceAmount", "priceNote"]
  static values = { interval: { type: String, default: "year" } }

  connect() {
    const interval = this.intervalFromUrl()
    this.syncRadio(interval)
    this.showInterval(interval)
    this.updateBillingLinks(interval)
  }

  selectInterval(event) {
    const interval = event.target.value
    this.showInterval(interval)
    this.updateBillingLinks(interval)
    this.updateUrl(interval)
  }

  showInterval(interval) {
    const isYear = interval === "year"

    // Toggle CTA buttons (current plan switch monthly/yearly)
    this.monthlyTargets.forEach((el) => el.classList.toggle("d-none", isYear))
    this.annualTargets.forEach((el) => el.classList.toggle("d-none", !isYear))

    // Update price amounts
    this.priceAmountTargets.forEach((el) => {
      el.textContent = isYear ? el.dataset.annualPrice : el.dataset.monthlyPrice
    })

    // Update price notes (innerHTML to support bold formatting)
    this.priceNoteTargets.forEach((el) => {
      el.innerHTML = isYear ? el.dataset.annualNote : el.dataset.monthlyNote
    })
  }

  syncRadio(interval) {
    this.intervalInputTargets.forEach((input) => {
      input.checked = input.value === interval
    })
  }

  updateBillingLinks(interval) {
    const base = window.location.href
    this.billingLinkTargets.forEach((link) => {
      const url = new URL(link.href, base)
      url.searchParams.set("interval", interval)
      link.href = url.toString()
    })
  }

  updateUrl(interval) {
    const url = new URL(window.location.href)
    url.searchParams.set("interval", interval)
    window.history.replaceState({}, "", url.toString())
  }

  intervalFromUrl() {
    const params = new URL(window.location.href).searchParams
    const interval = params.get("interval")
    if (interval === "month" || interval === "year") return interval
    return this.intervalValue === "month" || this.intervalValue === "year" ? this.intervalValue : "year"
  }
}
